import getLogger from '@ignitesales/logger-es';
import ignite from '../ignite.mjs';

const logger = getLogger({ module: 'social-action-creators' });

const sendResultsViaEmail = (
  {
    fromEmail,
    email,
    message,
    copyMe = false
  }
) => {
  return async () => {
    try {
      await ignite.contactService.emailResults({
        from: {
          email: fromEmail || email
        },
        to: {
          email
        },
        message,
        copyMe
      });
    } catch (ex) {
      logger.error('Error while emailing results', ex);
    }
  };
};

const sendResultsViaSms = phoneNumber => {
  return async () => {
    try {
      await ignite.contactService.textResults(phoneNumber);
    } catch (ex) {
      logger.error('Error while sending results via text message', ex);
    }
  };
};

export {
  sendResultsViaEmail,
  sendResultsViaSms
};
